import { render } from "./LoadCRA.vue?vue&type=template&id=5617904b&scoped=true"
import script from "./LoadCRA.vue?vue&type=script&lang=js"
export * from "./LoadCRA.vue?vue&type=script&lang=js"

import "./LoadCRA.vue?vue&type=style&index=0&id=5617904b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5617904b"]])

export default __exports__